export var SubscriptionCancelReason = /*#__PURE__*/function (SubscriptionCancelReason) {
  SubscriptionCancelReason["Moved"] = "MOVED";
  SubscriptionCancelReason["Sold"] = "SOLDCAR";
  SubscriptionCancelReason["NonUse"] = "NONUSE";
  SubscriptionCancelReason["Damaged"] = "DAMAGED";
  SubscriptionCancelReason["Incompatible"] = "INCOMPATIBLE";
  SubscriptionCancelReason["Weather"] = "WEATHER";
  SubscriptionCancelReason["Unsatisfied"] = "UNSATISFIED";
  SubscriptionCancelReason["Financial"] = "FINANCIAL";
  SubscriptionCancelReason["SignUpError"] = "SIGNUPERROR";
  SubscriptionCancelReason["Other"] = "OTHER";
  SubscriptionCancelReason["FailedInvoice"] = "FAILEDINVOICE";
  return SubscriptionCancelReason;
}(SubscriptionCancelReason || {});
export const SubscriptionCancelReasons = {
  [SubscriptionCancelReason.Moved]: "Moved",
  [SubscriptionCancelReason.NonUse]: "Non-use",
  [SubscriptionCancelReason.Sold]: "Sold car",
  [SubscriptionCancelReason.Financial]: "Financial",
  [SubscriptionCancelReason.FailedInvoice]: "Failed Invoice",
  [SubscriptionCancelReason.Weather]: "Weather",
  [SubscriptionCancelReason.Damaged]: "Damaged",
  [SubscriptionCancelReason.Unsatisfied]: "Unsatisfied",
  [SubscriptionCancelReason.Incompatible]: "Incompatible",
  [SubscriptionCancelReason.SignUpError]: "Sign-Up Error",
  [SubscriptionCancelReason.Other]: "Other / Declined to State"
};
